<template>
  <div class="animated fadeIn"> 
    <b-row>
      <b-col sm="12">
        <b-card>
          <div slot="header">
            <strong>Download COD MIS Report</strong>       
          </div>  
          <div class="box">
            <form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">
              <b-row>
                <b-col md="4" >
                  <b-form-group label="Service Center:"  :label-cols="3" >
                   <b-form-select v-model="hubid" name="hubid" v-validate="'required|'" >
                        <option :value="selected">--Selected Service Center--</option>
                        <option :value="hubs.pickuplocationmasterid" v-for="hubs in hubdata">{{ hubs.pickuplocationname | capitalize }}</option>s
                    </b-form-select>                 
                  </b-form-group>
                </b-col>
                 

                <b-col md="3" >
                  <b-form-group label="From Date :"  :label-cols="3" >
                  <v-date-picker mode='single' input-class="dateInput" :available-dates='{ start: null, end: new Date() }' v-model='selectDateFrom'>
                  </v-date-picker>                
                  </b-form-group>
                </b-col>

                <b-col md="3" >
                  <b-form-group label="To Date:"  :label-cols="3" >
                    <v-date-picker mode='single' input-class="dateInput" :available-dates='{ start: null, end: new Date() }' v-model='selectDateTo'>
                    </v-date-picker>               
                  </b-form-group>
                </b-col>
                <b-col md="2" >
                  <b-button size="sm" variant="primary" type="submit" @click="downloadCSV">Download MIS Report</b-button>
                </b-col>
              </b-row> 
            

            </form>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>    
</template>

<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
export default {
  data: function() {
    return {
      data: [],
      selected:'',
      showdata: [],
      selectDateFrom: new Date(),
      selectDateTo:new Date(),
      hubdata:[]
    };
  },
  computed: {},
  created: function() {
    this.displayHubdata();

  },
  methods: {
    validateForm(scope) {},
    getDownloadCsvObject: function(result) {
      var csvData = result;
      var today = new Date();
      var dd = today.getDate();
      var mm = today.getMonth() + 1;
      var yyyy = today.getFullYear();
      var today = dd + "" + mm + "" + yyyy;
      var data, filename, link;
      filename = "CodMISReport_" + today + ".csv";
      var csv = this.convertArrayOfObjectsToCSV({
        data: csvData
      });
      if (csv == null) return;
      filename = filename || "export.csv";
      if (!csv.match(/^data:text\/csv/i)) {
        csv = "data:text/csv;charset=utf-8," + csv;
      }
      data = encodeURI(csv);
      link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.removeChild(link);
    },
    downloadCSV: function() {
      var fromdate = (this.selectDateFrom!=null)?this.formatDate(this.selectDateFrom):"";
      var formatdateto=(this.selectDateTo!=null)? this.formatDate(this.selectDateTo):"";
      var csvObj = {
        fromdate: `${fromdate}`,
        todate:`${formatdateto}`,
        serviceid: `${this.hubid}`
      };
      if(formatdateto< fromdate){
            alert('To date need to be grater than From date')
      }
      this.$http
        .post(
          `${CONSTANTS.API_URL}/GetCodMisReport`,
          csvObj
        )
        .then(result => {
          if (result.data.returnmsg == "successful") {
            this.getDownloadCsvObject(result.data.returnvalue);
            alert("MIS Report Downloaded Successfully");
          } else {
            alert(result.body.returnmsg);
          }
        })
        .catch(ex => {
          console.log("error-----", ex);
        });
    },

    convertArrayOfObjectsToCSV: function(args) {
       var result, ctr, keys, columnDelimiter, lineDelimiter, data;
       data = args.data || null;
       if (data == null || !data.length) {
         return null;
       }
       columnDelimiter = args.columnDelimiter || ",";
       lineDelimiter = args.lineDelimiter || "\n";
       keys = Object.keys(data[0]).slice(0,-4);
       result = "";
       result += keys.join(columnDelimiter);
       result += lineDelimiter;
       data.forEach(function(item) {
       var logdata = item['logdata'];
       var attempt = item['attempt'];
       var allowcheckedin = item['allowcheckedin']
       item['deliverydate'] = '';
       item['deliverytime'] = '';

         if(logdata!==null){


           logdata.forEach(function(itm){
             let mydate = new Date(itm.createddate);
             let month=mydate.getMonth()+1;
             let createddate=""+mydate.getFullYear()+"-"+month+"-"+mydate.getDate()+" "+mydate.getHours()+":"+mydate.getMinutes();
             switch(itm.process) {

               case 'DLV':
               item['deliverydate'] = item['deliverycheckintime1'];
               item['deliverytime'] = createddate.toString();
               break;

                case 'NDR':
                item['deliverydate'] = null;
                item['deliverytime'] = null;
                break;
              }

           });
         } else {
           item['deliverytime'] = '';
           item['deliverydate'] = '';

         }
         ctr = 0;
         keys.forEach(function(key) {
           if (ctr > 0) result += columnDelimiter;
           if (item[key] != null) {
             result += '"' + item[key] + '"';
           }
           ctr++;
         });
         result += lineDelimiter;
       });
       return result;
     },
    formatDate: function(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();
      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      return [year, month, day].join("-");
    },
    displayHubdata: function() {

      const deliveryagentobj = {}
      this.$http.post(`${CONSTANTS.API_URL}/P2PReports/GetAllHubListMaster`)
        .then(result => {
          this.hubdata = result.body.returnvalue;
        })
        .catch(ex => {
          console.log('error-----', ex)
        });

      }
  },filters: {
    capitalize: function (value) {
    if (!value) return ''
    value = value.toString()
    return value.charAt(0).toUpperCase() + value.slice(1)
    }
  }
};
</script>
